import type { Note } from "@/core/types";

export function isAuthorizedToViewFullNote(note: Note, role: string | false): boolean {
  const isBhsTherapySessionNote =
    (note.provider_type === "BEHAVIORAL" || note.provider_type === "BEHAVIORAL_INTAKE") &&
    (note.note_type === "Video Consultation" || note.version === 2);

  switch (role) {
    case "provider:pcp":
      return !isBhsTherapySessionNote;

    default:
      return true;
  }
}
